import { arrayClear, arrayElRemoveByIndex } from '@/utilities/ArrayUtils';

const ObjAlertState = {
  store:         [],
  item:          {
    'text':      '',
    'status':    1,
    'startTime': 10
  },
  statusClasses: [
    /* 0 */'alert alert-success',
    /* 1 */ 'alert alert-info',
    /* 2 */ 'alert alert-warning',
    /* 3 */  'alert alert-danger'
  ],
  set(item, status = null) {
    const res = Object.assign({}, this.item);
    if (typeof item === 'string') {
      res.text = item;
    } else if (typeof item === 'object') {
      Object.assign(res, item)
    }
    if (status !== null) {
      switch (status) {
        case 'success':
          status = 0;
          break;
        case 'info':
          status = 1;
          break;
        case 'warning':
          status = 2;
          break;
        case 'danger':
          status = 3;
          break;
      }
      res.status = status;
    }
    this.add(res);
  },
  add(message) {
    this.store.push(message);
  },
  deleteOne(index) {
    arrayElRemoveByIndex(this.store, index);
  },
  deleteAll() {
    arrayClear(this.store)
  }
};
export default ObjAlertState;
